module.exports = __webpack_public_path__ + "static/media/pod-online.97050380.svg";